module.exports = __webpack_public_path__ + "static/assets/d1c616fd1b7c9f1d5a574adf6cc8b6fe.svg";